import { ReactElement } from 'react';
import withBehaviors, { WithBehaviorsProps } from 'ia-react-core/~/hocs/withBehaviors';
import withShow from 'ia-react-core/~/hocs/withShow';
import compose from '../../../utils/components/_compose';
import withFormState from '../../../hocs/form/_withFormState';

import withControl from './withControl';
import CheckboxListControl, { CheckboxListControlProps } from './CheckboxListControl';

export * from './CheckboxListControl';

const ComposedCheckboxListControl: <Value extends null | object | string | number | boolean, StateValue>(props: WithBehaviorsProps<CheckboxListControlProps<Value, StateValue>>) => ReactElement<WithBehaviorsProps<CheckboxListControlProps<Value, StateValue>>> = compose<any>(
  withBehaviors,
  withShow,
  withFormState,
  withControl,
)(CheckboxListControl);

export default ComposedCheckboxListControl;
